import { StandardTeaserLayoutContextType } from '@contexts/standardTeaser'
import { ViewportTypeValues } from '@contexts/viewport'
import { TeaserFlexValueDesktop } from '../types'
import { computeTeaserWidth } from '../utils'
import {
  ComputedStandardTeaserImageRatio,
  ComputedStandardTeaserImageWidth,
} from './types'

type GetImageRatioProps = Pick<
  StandardTeaserLayoutContextType,
  'isInMegaModule'
>

interface ComputeImageWidthProps
  extends Pick<StandardTeaserLayoutContextType, 'isInMegaModule'> {
  teaserFlexDesktop: TeaserFlexValueDesktop
}

const getImageRatio = ({
  isInMegaModule,
}: GetImageRatioProps): ComputedStandardTeaserImageRatio => {
  return {
    desktop: isInMegaModule ? '1_1' : '16_9',
    tablet: isInMegaModule ? '1_1' : '16_9',
    mobile: '1_1',
  }
}

const computeImageWidth = ({
  isInMegaModule,
  teaserFlexDesktop,
}: ComputeImageWidthProps): ComputedStandardTeaserImageWidth => ({
  desktop: isInMegaModule
    ? 150
    : Math.ceil(
        computeTeaserWidth({
          viewportType: ViewportTypeValues.DESKTOP,
          flexValue: teaserFlexDesktop,
        })
      ),
  tablet: isInMegaModule
    ? 150
    : Math.ceil(
        computeTeaserWidth({
          viewportType: ViewportTypeValues.TABLET,
          flexValue: '3',
        })
      ),
  mobile: 160,
  mobileSmall: 150,
})

export { getImageRatio, computeImageWidth }
